<div>
    <div adaptBlockingButtonGroup>
        <button [adaptBlockingClick]="doCheck"
                adaptButton="default">Get cache status</button>
        <button [adaptBlockingClick]="doClear"
                adaptButton="default">Clear cache</button>
    </div>

    @for (cache of cacheStatuses; track cache) {
        <div>
            <hr />
            <h3 class="d-flex w-100 align-items-center">
                <span>{{ cache.Name }}</span>
                <button (click)="doClearByName(cache.Name)"
                        adaptButtonIcon="delete"
                        class="ms-auto">Clear</button>
            </h3>
            <table class="table table-bordered table-striped table-hover table-responsive">
                <thead>
                    <tr>
                        <td style="width: 60%">Key</td>
                        <td>Value</td>
                    </tr>
                </thead>
                <tbody>
                    @for (status of cache.Values; track status) {
                        <tr>
                            <td>{{ status.Id }}</td>
                            <td>{{ status.Value }}</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    }

    @if (error) {
        <div role="alert"
             class="alert alert-danger">{{ error }}</div>
    }
</div>
